import { useTranslation } from 'react-i18next';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Img11 from '../../../../assets/img11.png';
import Company from '../../../../types/Company';
import { StyledDescription } from '../StateCard/styled';
import { StyledCard, StyledTitle } from './styled';

interface Props {
    company: Company;
}

const InfoCard = (props: Props) => {
    const { company } = props;
    const { name, address, city, country, state } = company;

    const { t } = useTranslation();

    const stateDescription = t('models.company.enum.state.' + state);

    return (
        <StyledCard variant='outlined'>
            <CardContent style={{ height: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div>
                        <StyledTitle style={{ fontSize: '1.65rem', fontWeight: 500 }}>
                            {name}
                        </StyledTitle>
                    </div>
                    <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flexGrow: 1, minHeight: '16px' }} />
                        <div style={{ display: 'flex' }}>
                            <div>
                                <img alt='Map marker' src={Img11} style={{ maxHeight: '44px', marginRight: '8px', marginTop: '2px' }} />
                            </div>
                            <div>
                                <Typography variant='body2' component='p' style={{ fontSize: '1.2rem' }}>
                                    {address} <br />
                                    {city}<br />
                                    {country.name}
                                </Typography>
                            </div>
                        </div>
                        <div style={{ flexGrow: 1, minHeight: '16px' }} />
                    </div>
                    <div style={{ marginBottom: '-12px' }}>
                        <StyledDescription>
                            {stateDescription}
                        </StyledDescription>
                    </div>
                </div>



            </CardContent>
        </StyledCard>
    );
};

export default InfoCard;
